import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from '../../utils/authFetch';

const ExcluirFuncao = () => {
    const { id } = useParams();
    const { showNotification } = useNotification();
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [confirmDelete, setConfirmDelete] = useState(false);

    useEffect(() => {
        const fetchFuncao = async () => {
            try {
                const response = await authFetch(`job-position/${id}`, {
                });

                if (!response.ok) throw new Error('Erro ao buscar função');

                const data = await response.json();
                setName(data.name);
            } catch (error) {
                console.error(error);
                showNotification("danger", "Erro ao buscar função");
            }
        };

        fetchFuncao();
    }, [showNotification]);

    const handleDelete = async (e) => {
        e.preventDefault();

        if (!confirmDelete) {
            showNotification("danger", "Confirme a exclusão marcando o checkbox.");
            return;
        }

        try {
            const response = await authFetch(`job-position/${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) throw new Error('Erro ao excluir função');

            showNotification("success", "Função excluída com sucesso!");
            navigate('/Funcoes');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao excluir função");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Excluir Função</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleDelete}>
                                <fieldset className="col-md-6">
                                    <p>Tem certeza que deseja excluir a função <strong>{name}</strong>?</p>

                                    <div className="form-check mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="confirmDelete"
                                            checked={confirmDelete}
                                            onChange={(e) => setConfirmDelete(e.target.checked)}
                                            required
                                        />
                                        <label className="form-check-label" htmlFor="confirmDelete">
                                            Confirmo a exclusão desta função
                                        </label>
                                    </div>

                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to={'/Funcoes'} className="btn btn-info btn-sm">Cancelar</Link>
                                        <button type="submit" className="btn btn-danger btn-sm mx-1">Excluir</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExcluirFuncao;
